(()=>{
  const initGallery=root=>{
    if(!root||root.dataset.akMobileGalleryReady==='true')return;

    const mainWrap=root.querySelector('[data-ak-main-media]');
    const rail=root.querySelector('.ak-product-thumbs');
    const thumbs=[...root.querySelectorAll('[data-ak-product-thumb]')];
    if(!mainWrap||!rail||thumbs.length<2)return;

    root.dataset.akMobileGalleryReady='true';
    thumbs.forEach((thumb,index)=>thumb.dataset.akGalleryIndex=String(index));

    let current=Math.max(0,thumbs.findIndex(thumb=>thumb.classList.contains('is-active')));
    let startX=null;
    let startY=null;

    const centerThumb=(index,behavior='smooth')=>{
      const thumb=thumbs[index];
      if(!thumb)return;
      const target=thumb.offsetLeft-(rail.clientWidth-thumb.offsetWidth)/2;
      rail.scrollTo({left:Math.max(0,target),behavior});
    };

    const updateCounter=()=>{
      if(counter)counter.textContent=`${current+1} / ${thumbs.length}`;
    };

    const show=index=>{
      current=((index%thumbs.length)+thumbs.length)%thumbs.length;
      const thumb=thumbs[current];
      if(!thumb)return;
      thumb.click();
      centerThumb(current);
      updateCounter();
    };

    const makeArrow=(direction,label)=>{
      const button=document.createElement('button');
      button.type='button';
      button.className=`ak-pdp-mobile-gallery-arrow ak-pdp-mobile-gallery-arrow--${direction}`;
      button.setAttribute('aria-label',label);
      button.innerHTML='<span aria-hidden="true"></span>';
      button.addEventListener('click',event=>{
        event.preventDefault();
        event.stopPropagation();
        show(current+(direction==='next'?1:-1));
      });
      mainWrap.appendChild(button);
      return button;
    };

    makeArrow('prev','Previous product media');
    makeArrow('next','Next product media');

    const counter=document.createElement('span');
    counter.className='ak-pdp-mobile-gallery-count';
    counter.setAttribute('aria-hidden','true');
    mainWrap.appendChild(counter);

    thumbs.forEach((thumb,index)=>{
      thumb.addEventListener('click',()=>{
        current=index;
        centerThumb(current);
        updateCounter();
      });
    });

    /* Passive swipe detection only: never cancel native page scrolling or video controls. */
    mainWrap.addEventListener('touchstart',event=>{
      if(event.target.closest?.('video,iframe,[controls]'))return;
      if(event.touches.length!==1)return;
      startX=event.touches[0].clientX;
      startY=event.touches[0].clientY;
    },{passive:true});

    mainWrap.addEventListener('touchend',event=>{
      if(startX===null||startY===null)return;
      const touch=event.changedTouches?.[0];
      if(!touch){startX=startY=null;return}
      const dx=touch.clientX-startX;
      const dy=touch.clientY-startY;
      startX=startY=null;
      if(Math.abs(dx)<42||Math.abs(dx)<=Math.abs(dy)*1.2)return;
      show(current+(dx<0?1:-1));
    },{passive:true});

    mainWrap.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'){event.preventDefault();show(current-1)}
      if(event.key==='ArrowRight'){event.preventDefault();show(current+1)}
    });

    updateCounter();
    centerThumb(current,'auto');
  };

  const initAll=(scope=document)=>scope.querySelectorAll?.('[data-ak-product-page]').forEach(initGallery);
  document.addEventListener('DOMContentLoaded',()=>initAll(document));
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
  window.addEventListener('pageshow',()=>initAll(document));
})();